const ORIGIN_LABELS: Record<string, string> = {
	EMAIL: "Email",
	WIDGET: "Widget",
	LIVE_CHAT: "Live chat",
	AI_CHAT: "AI chat",
	SLACK: "Slack",
	SLACK_CONNECT: "Slack Connect",
	TEAMS: "Teams",
	PORTAL: "Portal",
	SUPPORT_PORTAL: "Support portal",
	API: "API",
	INAPP: "In-app",
	LINEAR: "Linear",
	UPVOTE: "Upvote",
}

export const originLabel = (origin: string) =>
	ORIGIN_LABELS[origin] ??
	origin
		.toLowerCase()
		.split("_")
		.map((part, index) =>
			index === 0 ? part.charAt(0).toUpperCase() + part.slice(1) : part,
		)
		.join(" ")

export const formatMrr = (mrr: number | null) =>
	mrr === null ? null : `€${Math.round(mrr).toLocaleString("de-DE")}`

export const billingLabel = ({
	plan,
	subscriptionStatus,
	trialDaysLeft,
}: {
	plan: string
	subscriptionStatus: string | null
	trialDaysLeft: number | null
}) => {
	if (subscriptionStatus === "trialing") {
		return trialDaysLeft === 1
			? "Trial, 1 day left"
			: `Trial, ${trialDaysLeft ?? 0} days left`
	}
	if (subscriptionStatus && subscriptionStatus !== "active") {
		return `${capitalize(plan)}, ${subscriptionStatus.replace("_", " ")}`
	}
	return capitalize(plan)
}

const capitalize = (value: string) =>
	value.charAt(0).toUpperCase() + value.slice(1)
